import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { NotasNaVersao } from '../notas-versao';

/**
 * Desenha as notas de UMA versão com a hierarquia que o texto publicado tem:
 * manchete da versão, cabeçalho de seção e item. Serve os dois modos da modal (a
 * versão nova, pós-login, e cada versão do histórico) e os dois blocos (web e
 * aplicativo), para o mesmo texto nunca aparecer de dois jeitos.
 *
 * O item não leva ícone de confirmação: quando toda linha ganha um check verde, o
 * check deixa de significar algo e o cabeçalho de seção vira "mais uma novidade".
 * O marcador é um ponto discreto, e o peso/tamanho do texto faz a hierarquia.
 */
@Component({
  selector: 'app-notas-da-versao',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'flex flex-col gap-4' },
  template: `
    @if (notas().titulo) {
      <h4 class="text-base font-semibold text-content-primary">{{ notas().titulo }}</h4>
    }

    @if (notas().secoes.length) {
      <div class="flex flex-col gap-5">
        @for (secao of notas().secoes; track $index) {
          <div class="flex flex-col gap-2">
            @if (secao.titulo) {
              <h5 class="text-xs font-semibold uppercase tracking-wide text-content-tertiary">{{ secao.titulo }}</h5>
            }
            @if (secao.itens.length) {
              <ul class="flex flex-col gap-2">
                @for (item of secao.itens; track $index) {
                  <li class="flex gap-2.5 text-sm text-content-secondary">
                    <span class="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-color-brand/70" aria-hidden="true"></span>
                    <span class="min-w-0">{{ item }}</span>
                  </li>
                }
              </ul>
            }
          </div>
        }
      </div>
    } @else if (!notas().titulo) {
      <p class="text-sm text-content-secondary">Esta versão traz melhorias e correções.</p>
    }
  `,
})
export class NotasDaVersaoComponent {
  readonly notas = input.required<NotasNaVersao>();
}
